import React, {useEffect, useState} from 'react';
import {VStack, HStack, Divider} from 'native-base';
import { useDispatch, useSelector } from 'react-redux';
import AppText from '../../../../../../common/AppText';
import { GlobalStyleAttributes } from '../../../../../../../styles/GlobalStyles';
import { t } from '../../../../../../../services/i18n';
import CustomButtonV2 from '../../../../../../common/CustomButtonV2';
import { GlobalConsts } from '../../../../../../../styles/GlobalConsts';
import IconsGenerator from '../../../../../../Icons8Generator/IconsGenerator';
import {getCalendarSync, updateBox} from "../../../../../../../redux/boxSlice";
import {Colors} from "../../../../../../../styles/Colors";
import CustomSwitch from "../../../../../../common/CustomSwitch";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ConfirmModal from "../../../../../../common/ConfirmModal";
import {isMobile} from "../../../../../../../services/Helpers";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import ConnectButton from './components/ConnectButton';
import {toggleScheduleLoader, toggleSuccessFlag} from "../../../../../../../redux/ScheduleSlice";
import {fetchApi} from "../../../../../../../services/HTTP";
import useGoogleCalendarSync from "../../../../../../../Hooks/useGoogleCalendarSync";
import {Skeleton} from "antd";
import {setAngularPath} from "../../../../../../../redux/rootManagerSlice";

const GoogleCalendarSync = (props) => {
    const { values, setFieldValue, errors } = props;
    const dispatch = useDispatch();
    const calendarSync = useSelector((state) => state.box.box.calendarSync);
    const user = useSelector(state => state.user.user);
    const showCheckForConflicts = useSelector(state => state.box.box.show_check_for_conflicts);
    const shouldSave = useSelector((state) => state.schedule.settingsSaveFlag);
    const [addToCalendar, setAddToCalendar] = useState(calendarSync?.add_to_calendar || false);
    const [checkForConflicts, setCheckForConflicts] = useState(calendarSync?.check_for_conflicts || false);
    const [showActionMessage, setShowActionMessage] = useState(true);
    const [loader, setLoader] = useState(true);
    const [connection, setConnection] = useState(false)
    const [disconnect, setDisconnect] = useState(false)

    const {
        confirm,
        disableConnection,
        disableReason,
    } = useGoogleCalendarSync({
        onConnectSuccess: (res) => {
            setAddToCalendar(res?.add_to_calendar);
            setCheckForConflicts(res?.check_for_conflicts);
            dispatch(updateBox({ calendarSync: res }));
        },
        onDisconnectSuccess: (res) => {
            dispatch(updateBox({ calendarSync: res }));
        },
        connection,
        disconnect
    });

    useEffect(() => {
        dispatch(getCalendarSync());
    }, []);

    useEffect(() => {
        if (calendarSync !== undefined) {
            setLoader(false);
            setAddToCalendar(calendarSync?.add_to_calendar || false);
            setCheckForConflicts(calendarSync?.check_for_conflicts || false);
        }
    }, [calendarSync]);

    useEffect(() => {
        if(shouldSave) {
            save()
        }
    }, [shouldSave]);

    useEffect(() => {
        if (calendarSync?.status === 'active') {
            setShowActionMessage(true);
            const timer = setTimeout(() => {
                setShowActionMessage(false);
            }, 5 * 60 * 1000);

            return () => clearTimeout(timer);
        }
    }, [calendarSync?.status]);

    const toggleCheckForConflict = (value) => {
        setCheckForConflicts(value);
        if (setFieldValue) {
            setFieldValue('calendarSync.check_for_conflicts', value);
        }
        dispatch(updateBox({check_for_conflicts: value}));
    };

    const toggleAddToCalendar = (value) => {
        setAddToCalendar(value);
        if (setFieldValue) {
            setFieldValue('calendarSync.add_to_calendar', value);
        }
        dispatch(updateBox({add_to_calendar: value}));
    };

    const save = async () => {
        try {
            if (isMobile) {
                dispatch(toggleScheduleLoader(true));
                const setting = {check_for_conflicts: values.calendarSync.check_for_conflicts, add_to_calendar: values.calendarSync.add_to_calendar}
                const res = await fetchApi('calendarSyncConnections/syncSettings', 'post', setting, false, true);
                dispatch(toggleScheduleLoader(false));
                dispatch(toggleSuccessFlag(true))
                dispatch(updateBox({calendarSync: res}));
            }
        }catch(error) {
            console.log('error',error)
            dispatch(toggleScheduleLoader(false));
        }
    }

    return (loader ? <VStack space={'1rem'}>
                <AppText fontSize={isMobile ? GlobalStyleAttributes.fonts.mainHeader : GlobalStyleAttributes.fonts.standard16} boldFont>{t('googleCalendarSync')}</AppText>
                <VStack>
                    <Skeleton active paragraph={{rows: 1, width: '80%'}} title={false}/>
                    <Skeleton active paragraph={{rows: 1, width: '90%'}} title={false}/>
                    <Skeleton active paragraph={{rows: 1, width: '100%'}} title={false}/>
                </VStack>
            </VStack> :
        <VStack space={'1.5rem'}>
            <VStack space={'1rem'}>
                <AppText fontSize={isMobile ? GlobalStyleAttributes.fonts.mainHeader : GlobalStyleAttributes.fonts.standard16} boldFont>{t('googleCalendarSync')}</AppText>
                <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>
                    {calendarSync?.status === 'active' ? t('googleCalendarSyncTxtConnected') : t('googleCalendarSyncTxt')}
                    {' '}
                    <span onClick={() => window.open(t('learn-more-link'), '_blank')}
                          style={{color: Colors.newDesign.mainBlue, cursor: 'pointer'}}>
                        {t('learn-more')}
                    </span>
                </AppText>
                {calendarSync && calendarSync?.status === 'active' ? <CustomButtonV2 override={({color, isHovered}) => (
                    <HStack justifyContent={'space-between'} style={{border: 'solid 1px ' + Colors.newDesign.avatarBgColor, borderRadius: '4px'}}
                            padding={'15px'} width={'100%'} backgroundColor={isHovered && Colors.newDesign.menuBar}>
                        <HStack alignItems={'center'} space={'1rem'}>
                            <IconsGenerator size={GlobalConsts.iconSize.M} name={'googleCalendar'}/>
                            {calendarSync?.status === 'active' ? <AppText color={color}>{user.email}</AppText> : <AppText color={color}>{t('connect-to-your-google-account')}</AppText>}
                        </HStack>
                        <CustomButtonV2 onClick={() => setDisconnect(true)} type="link" iconName={'fa-link-simple-slash'} iconProps={{iconColor: Colors.newDesign.mainText, iconSize: GlobalConsts.iconSize.XS}} tooltipText={t('disconnect-tooltip')}/>
                    </HStack>
                )}/> :
                    <ConnectButton
                        onConnect={() => setConnection(true)}
                        disabled={disableConnection}
                        disableReason={disableReason}
                    />
                }
                {calendarSync && calendarSync?.status === 'disconnected' && <HStack space={'0.5rem'} alignItems={'center'}>
                    <FontAwesomeIcon icon={solid('triangle-exclamation')}/>
                    <AppText>{t('disconnect-due-to', {error: t(calendarSync.disconnect_reason)})}</AppText>
                </HStack>}
                {calendarSync && calendarSync?.status === 'active' && showActionMessage && <AppText color={Colors.newDesign.darkGrey}>{t('action-may-take-a-while')}</AppText>}
            </VStack>
            {calendarSync?.status === 'active' && <>
            <VStack space={'0.25rem'}>
                <HStack justifyContent={'space-between'} alignItems={'center'}>
                    <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{t('add-to-calendar')}</AppText>
                    <CustomSwitch isChecked={addToCalendar} onToggle={toggleAddToCalendar}/>
                </HStack>
                <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('add-to-calendar-txt')}</AppText>
            </VStack>
            {showCheckForConflicts && <>
                <Divider w={'100%'} color={Colors.borderColor}/>
                <VStack space={'0.25rem'}>
                    <HStack justifyContent={'space-between'} alignItems={'center'}>
                        <AppText fontSize={GlobalStyleAttributes.fonts.standard16}
                                 boldFont>{t('check-for-conflicts')}</AppText>
                        <CustomSwitch isChecked={checkForConflicts} onToggle={toggleCheckForConflict}/>
                    </HStack>
                    <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('check-for-conflicts-txt')}</AppText>
                </VStack>
            </>}
            </>}
            {confirm}
    </VStack>
    )
}

export default GoogleCalendarSync;